/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle, transitionBase, } from '@vital-ui/react-utils';
import { RadioContext } from './RadioContext';
var Root = styled('label')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  margin: 0 5px 10px 0;\n  word-break: break-word;\n  color: ", ";\n  line-height: 1.3333rem;\n  font-size: 1rem;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :hover {\n    input {\n      box-shadow: 0 0 0 2px rgba(14, 134, 254, 0.2);\n      border-color: ", ";\n    }\n  }\n  ", ";\n  ", ";\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  margin: 0 5px 10px 0;\n  word-break: break-word;\n  color: ", ";\n  line-height: 1.3333rem;\n  font-size: 1rem;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :hover {\n    input {\n      box-shadow: 0 0 0 2px rgba(14, 134, 254, 0.2);\n      border-color: ", ";\n    }\n  }\n  ", ";\n  ", ";\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return theme.radio.color(disabled);
}, function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, function (props) { return (props.disabled ? 'none' : 'auto'); }, function (_a) {
    var theme = _a.theme;
    return theme.form.focusBorderColor;
}, superBoxStyle, function (_a) {
    var theme = _a.theme;
    return theme.radio.css;
});
Root.defaultProps = {
    theme: defaultTheme,
};
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  vertical-align: middle;\n  appearance: none;\n  outline: none;\n  position: relative;\n  box-sizing: content-box;\n  margin: -2px 0 0 0;\n  width: ", ";\n  height: ", ";\n  border: 1px solid ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  ", ";\n  cursor: pointer;\n\n  &:checked {\n    border-color: ", ";\n    background-color: ", ";\n\n    &:after {\n      opacity: 1;\n      transform: scale(1);\n      background: ", ";\n    }\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    left: ", ";\n    border-radius: 50%;\n    background: transparent;\n    opacity: 0;\n    pointer-events: none;\n    transform: scale(0);\n    ", ";\n  }\n"], ["\n  vertical-align: middle;\n  appearance: none;\n  outline: none;\n  position: relative;\n  box-sizing: content-box;\n  margin: -2px 0 0 0;\n  width: ", ";\n  height: ", ";\n  border: 1px solid ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  ", ";\n  cursor: pointer;\n\n  &:checked {\n    border-color: ",
    ";\n    background-color: ",
    ";\n\n    &:after {\n      opacity: 1;\n      transform: scale(1);\n      background: ",
    ";\n    }\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    top: ",
    ";\n    left: ",
    ";\n    border-radius: 50%;\n    background: transparent;\n    opacity: 0;\n    pointer-events: none;\n    transform: scale(0);\n    ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.radio.size;
}, function (_a) {
    var theme = _a.theme;
    return theme.radio.size;
}, function (_a) {
    var theme = _a.theme;
    return theme.form.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.radio.bg;
}, transitionBase, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled ? theme.colors.secondary400 : theme.radio.primary;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled ? theme.colors.secondary400 : theme.radio.checkedBg;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled ? theme.colors.secondary : theme.radio.checkedAfter;
}, function (_a) {
    var theme = _a.theme;
    return theme.radio.checkedSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.radio.checkedSize;
}, function (_a) {
    var theme = _a.theme;
    return "calc((" + theme.radio.size + " - " + theme.radio.checkedSize + ")/2)";
}, function (_a) {
    var theme = _a.theme;
    return "calc((" + theme.radio.size + " - " + theme.radio.checkedSize + ")/2)";
}, transitionBase);
Input.defaultProps = {
    theme: defaultTheme,
};
var Label = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-left: 4px;\n"], ["\n  padding-left: 4px;\n"])));
export var Radio = function (_a) {
    var label = _a.label, defaultChecked = _a.defaultChecked, style = _a.style, className = _a.className, inputClassName = _a.inputClassName, inputStyle = _a.inputStyle, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["label", "defaultChecked", "style", "className", "inputClassName", "inputStyle", "value", "onChange"]);
    return (React.createElement(RadioContext.Consumer, null, function (_a) {
        var name = _a.name, disabled = _a.disabled, seletedValue = _a.seletedValue, handleChange = _a.onChange;
        return (React.createElement(Root, { style: style, className: cn('vital__radio'), disabled: disabled },
            React.createElement(Input, __assign({ className: cn('vital__radio-input', inputClassName), style: inputStyle, disabled: disabled, type: "radio", defaultChecked: defaultChecked, checked: value === seletedValue, name: name, onChange: handleChange ? function () { return handleChange(value); } : onChange }, props)),
            React.createElement(Label, null, label)));
    }));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Radio.js.map